import "./App.css";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import aeonLogo from "./Assets/logo.png";
import "./nav.css";
import ContactUs from "./Components/ContactPages/ContactUs.jsx";
import RequestDemo from "./Components/ContactPages/RequestDemo.jsx";
import "./Components/ContactPages/contactPage.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./Components/Home.jsx";
import Services from "./Components/Services.jsx";
import facebook from "./Assets/Footer/facebook.png";
import instagram from "./Assets/Footer/instagram.png";
import twitter from "./Assets/Footer/twitter.png";
import linkedIn from "./Assets/Footer/linkedIn.png";
import centerImg from "./Assets/Footer/centerImg.png";

function App() {
  const location = useLocation();
  const isActiveHome =
    location.pathname === "/" || location.pathname === "/home";
  const isActiveServices = location.pathname === "/services";
  const [showContact, setShowContact] = useState(false);
  const [showRequestDemo, setShowRequestDemo] = useState(false);

  const handleShowContact = () => {
    setShowContact(!showContact);
  };

  const handleShowRequestDemo = () => setShowRequestDemo(!showRequestDemo);
  return (
    <div className="App">
      <div className="nav-main">
        <Navbar
          collapseOnSelect
          expand="lg"
          className="bg-body-tertiary"
          id="navvbar"
          fixed="top"
        >
          <Container>
            <Navbar.Brand href="/">
              <img
                src={aeonLogo}
                width="50"
                className="d-inline-block align-top"
                alt="Fidus India"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto links-nav">
                <Nav.Link
                  href="/"
                  className={isActiveHome ? "nav-link active" : "nav-link"}
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  href="/services"
                  className={isActiveServices ? "nav-link active" : "nav-link"}
                >
                  Services
                </Nav.Link>
              </Nav>
              <Nav>
                <span
                  className="grey-circle toggleContactUs"
                  onClick={handleShowContact}
                >
                  <svg
                    className="nav-icons"
                    viewBox="0 0 18 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.0369 16.7313L12.2359 14.8526C12.1177 14.7684 11.9792 14.7172 11.8347 14.7043C11.6901 14.6914 11.5447 14.7172 11.4135 14.7792L10.3381 15.3246C10.2032 15.3909 10.0519 15.4164 9.90269 15.398C9.75349 15.3795 9.61292 15.318 9.49821 15.2208C7.48773 13.5571 6.14207 11.2264 5.70654 8.65344C5.67975 8.50551 5.69671 8.35299 5.75534 8.21456C5.81398 8.07614 5.91173 7.95783 6.03663 7.87416L7.01574 7.16203C7.13711 7.08209 7.23495 6.97121 7.29916 6.84083C7.36337 6.71045 7.39162 6.5653 7.38101 6.42036L7.15446 3.0553L7.10272 2.19336C7.09338 2.06931 7.05614 1.94897 6.99378 1.84133C6.89378 1.66663 6.73212 1.53559 6.54051 1.47391C6.01211 1.29803 5.44937 1.25078 4.89904 1.33609C4.34871 1.42139 3.82668 1.63679 3.37632 1.96438L3.15639 2.13177L3.04246 2.21911C2.98943 2.25736 2.9385 2.29846 2.8899 2.34221L2.74956 2.47712C0.897101 4.28757 1.24557 8.83914 3.63269 13.3588L4.35894 14.6167C7.07598 18.9377 10.8435 21.5153 13.3488 20.8542L13.5358 20.8001C13.5977 20.7801 13.6584 20.7567 13.7177 20.7302L13.8509 20.6762L14.1058 20.5694C14.6145 20.3429 15.0617 19.9984 15.4105 19.5644C15.7592 19.1304 15.9994 18.6194 16.1111 18.0739C16.1535 17.8772 16.1208 17.6716 16.0195 17.4977C15.9575 17.3899 15.8719 17.2974 15.7691 17.2273L15.0369 16.7313Z"
                      stroke="rgba(172, 130, 255, 1)"
                      stroke-width="2"
                      stroke-miterlimit="10"
                    />
                  </svg>
                </span>
                <span className="grey-circle grey-circle-2 toggleContactUs">
                  <svg
                    className="nav-icons"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.98012 17.44H22.0201M2.98012 6.56H22.0201M1.62012 12H23.3801M1.62012 12C1.62012 18.0089 6.49126 22.88 12.5001 22.88M1.62012 12C1.62012 5.99113 6.49126 1.12 12.5001 1.12M23.3801 12C23.3801 18.0089 18.509 22.88 12.5001 22.88M23.3801 12C23.3801 5.99113 18.509 1.12 12.5001 1.12M12.5001 22.88C12.5001 22.88 6.38012 20.16 6.38012 12C6.38012 3.84 12.5001 1.12 12.5001 1.12M12.5001 22.88C12.5001 22.88 18.6201 20.16 18.6201 12C18.6201 3.84 12.5001 1.12 12.5001 1.12M12.5001 22.88V1.12"
                      stroke="rgba(172, 130, 255, 1)"
                      stroke-width="1.8"
                    />
                  </svg>
                  <svg
                    width="15"
                    height="10"
                    viewBox="0 0 13 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.731602 0.901437C0.373644 1.2594 0.373644 1.83984 0.731602 2.1978L5.21621 6.67792C5.93221 7.39328 7.09253 7.39301 7.80826 6.67737L12.2911 2.1945C12.6491 1.83654 12.6491 1.2561 12.2911 0.898128C11.9331 0.540142 11.3527 0.540142 10.9947 0.898128L7.15789 4.73495C6.79993 5.093 6.2195 5.093 5.86154 4.73495L2.02795 0.901437C1.66999 0.543451 1.08965 0.543451 0.731602 0.901437Z"
                      fill="rgba(172, 130, 255, 1)"
                    />
                  </svg>
                </span>
                <button
                  className="request-demo-btn"
                  type="button"
                  onClick={handleShowRequestDemo}
                >
                  <span>Request Demo</span>
                </button>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

      <div className="contact-pages">
        <div className="contactUs-main-cont">
          {showContact && (
            <ContactUs
              showContact={showContact}
              setShowContact={setShowContact}
            />
          )}
        </div>
        <div>
          {showRequestDemo && (
            <RequestDemo
              showRequestDemo={showRequestDemo}
              setShowRequestDemo={setShowRequestDemo}
            />
          )}
        </div>
      </div>
      <div className="main-container">
        <Routes>
          <Route
            path="/"
            exact
            element={<Home handleShowContact={handleShowContact} />}
          />
          <Route path="/services" exact element={<Services />} />
        </Routes>
        <div className="sixth-container">
          <footer>
            <div className="sixth-inner-container">
              <div className="row m-0">
                <div className="col-lg-4">
                  <div className="left">
                    {/* <span className="font-inter">STAY UP TO DATE</span> */}
                    {/* <h1
                      className="font-cardo cardo-heading"
                      style={{ color: "black", lineHeight: "47px" }}
                    >
                      Get our
                      <div>updates</div>
                    </h1> */}

                    {/* <div className="emailer">
                      <input type="email" placeholder="Your Email" />
                      <button>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 37 37"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.25 18.5006H27.75M27.75 18.5006L20.0417 26.209M27.75 18.5006L20.0417 10.7923"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </button>
                    </div> */}
                    <img
                      src={aeonLogo}
                      width="250"
                      className="d-inline-block align-top"
                      alt="Fidus India"
                    />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="center">
                    <img src={centerImg} alt="img" />
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="right">
                    <span>GET IN TOUCH</span>
                    <div class="text-start">
                      <h2 className="font-cardo fw-bold">
                        enquiry@aeonsoftware
                      </h2>
                      <h2 className="font-cardo fw-bold">+91 2048465792</h2>
                    </div>
                    <p
                      className="font-inter inter-para"
                      style={{
                        color: "rgba(88, 88, 88, 1)",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      Unit No. 507, Lunkad Sky Vista, <br /> Lohegaon, Viman
                      nagar Pune <br />
                      411014.
                    </p>
                    {/* <div class="social">
                      <a href="/" target="__blank">
                        <img src={facebook} alt="facebook" />
                      </a>
                      <a href="https://x.com/fidus_india" target="__blank">
                        <img src={twitter} alt="" />
                      </a>
                      <a
                        href="https://www.instagram.com/fidus_india/"
                        target="__blank"
                      >
                        <img src={instagram} alt="" />
                      </a>
                      <a
                        href="https://in.linkedin.com/in/fidus-india-a5a030242?trk=public_post_follow-view-profile"
                        target="__blank"
                      >
                        <img src={linkedIn} alt="" />
                      </a>
                    </div> */}
                    <ul>
                      <li>
                        <a href="#">
                          <svg
                            width="50"
                            height="51"
                            className="icon"
                            viewBox="0 0 50 51"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_3205_10232)">
                              <path
                                d="M27.8008 11.2031C27.8008 9.1914 29.5977 8.46875 31.6094 8.46875C33.6211 8.46875 35.7695 9.09375 35.7695 9.09375L37.0586 1.4375C37.0586 1.4375 34.3242 0.5 27.8008 0.5C23.7969 0.5 21.4727 2.02344 19.7734 4.26953C18.1719 6.39844 18.1133 9.81641 18.1133 12.0234V17.043H12.9375V24.5234H18.1133V50.5H27.8008V24.5234H35.4766L36.043 17.043H27.8008V11.2031Z"
                                // fill="#4E465E"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_3205_10232">
                                <rect
                                  width="50"
                                  height="50"
                                  fill="white"
                                  transform="translate(0 0.5)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <svg
                            width="50"
                            height="51"
                            className="icon"
                            viewBox="0 0 50 51"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.725 45.4995C34.5925 45.4995 44.9125 30.1084 44.9125 16.7629C44.9125 16.3248 44.9125 15.89 44.8825 15.4568C46.89 14.0292 48.6225 12.2566 50 10.2285C48.13 11.0457 46.1425 11.5816 44.11 11.8178C46.25 10.5552 47.8525 8.57144 48.62 6.23069C46.605 7.40721 44.4025 8.23756 42.105 8.68308C38.22 4.61691 31.7225 4.4199 27.59 8.24485C24.9275 10.7111 23.795 14.3883 24.6225 17.8957C16.375 17.4872 8.69 13.6524 3.48 7.34397C0.757501 11.959 2.15 17.8607 6.6575 20.8242C5.025 20.7774 3.4275 20.3447 2 19.562V19.6902C2.0025 24.4972 5.445 28.6363 10.23 29.5888C8.72 29.995 7.135 30.0539 5.6 29.761C6.9425 33.8764 10.795 36.6951 15.1825 36.7763C11.55 39.5872 7.0625 41.1135 2.4425 41.1086C1.6275 41.1061 0.8125 41.0593 0 40.9634C4.6925 43.9268 10.15 45.4995 15.725 45.4922"
                              // fill="#4E465E"
                            />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <svg
                            width="61"
                            height="61"
                            className="icon insta"
                            viewBox="0 0 61 61"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M42.3162 18.3003H42.3416M20.3307 50.8337H40.6641C46.2789 50.8337 50.8307 46.2818 50.8307 40.667V20.3337C50.8307 14.7188 46.2789 10.167 40.6641 10.167H20.3307C14.7158 10.167 10.1641 14.7188 10.1641 20.3337V40.667C10.1641 46.2818 14.7158 50.8337 20.3307 50.8337ZM40.0287 30.5003C40.0287 35.7644 35.7614 40.0316 30.4974 40.0316C25.2334 40.0316 20.9661 35.7644 20.9661 30.5003C20.9661 25.2364 25.2334 20.9691 30.4974 20.9691C35.7614 20.9691 40.0287 25.2364 40.0287 30.5003Z"
                              // stroke="#4E465E"
                              stroke-width="5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <svg
                            width="45"
                            height="45"
                            className="icon"
                            viewBox="0 0 45 45"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_3205_10241)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M45 45H36V29.2522C36 24.9322 34.0943 22.522 30.6765 22.522C26.9573 22.522 24.75 25.0334 24.75 29.2522V45H15.75V15.75H24.75V19.0393C24.75 19.0393 27.5737 14.0845 33.9367 14.0845C40.302 14.0845 45 17.9687 45 26.0057V45ZM5.4945 11.072C2.45925 11.072 0 8.59266 0 5.53491C0 2.47941 2.45925 0 5.4945 0C8.5275 0 10.9867 2.47941 10.9867 5.53491C10.989 8.59266 8.5275 11.072 5.4945 11.072ZM0 45H11.25V15.75H0V45Z"
                                fill="#4E465E"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_3205_10241">
                                <rect width="45" height="45" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="copyright mt-3 font-inter">
                    <p
                      style={{
                        color: "rgba(88, 88, 88, 1)",
                        fontWeight: "600",
                        // fontSize: "21px",
                      }}
                    >
                      © 2025 Aeon software ME WLL, All Rights Reserved
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default App;
